(() => {
  var t = {
    1296: (t, n, e) => {
      var r = /^\s+|\s+$/g, o = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, u = /^0o[0-7]+$/i, c = parseInt,
        a = "object" == typeof e.g && e.g && e.g.Object === Object && e.g,
        f = "object" == typeof self && self && self.Object === Object && self, l = a || f || Function("return this")(),
        d = Object.prototype.toString, s = Math.max, v = Math.min, p = function () {
          return l.Date.now()
        };

      function h(t) {
        var n = typeof t;
        return !!t && ("object" == n || "function" == n)
      }

      function y(t) {
        if ("number" == typeof t) return t;
        if (function (t) {
          return "symbol" == typeof t || function (t) {
            return !!t && "object" == typeof t
          }(t) && "[object Symbol]" == d.call(t)
        }(t)) return NaN;
        if (h(t)) {
          var n = "function" == typeof t.valueOf ? t.valueOf() : t;
          t = h(n) ? n + "" : n
        }
        if ("string" != typeof t) return 0 === t ? t : +t;
        t = t.replace(r, "");
        var e = i.test(t);
        return e || u.test(t) ? c(t.slice(2), e ? 2 : 8) : o.test(t) ? NaN : +t
      }

      t.exports = function (t, n, e) {
        var r, o, i, u, c, a, f = 0, l = !1, d = !1, m = !0;
        if ("function" != typeof t) throw new TypeError("Expected a function");

        function g(n) {
          var e = r, i = o;
          return r = o = void 0, f = n, u = t.apply(i, e)
        }

        function w(t) {
          return f = t, c = setTimeout(E, n), l ? g(t) : u
        }

        function b(t) {
          var e = t - a;
          return void 0 === a || e >= n || e < 0 || d && t - f >= i
        }

        function E() {
          var t = p();
          if (b(t)) return j(t);
          c = setTimeout(E, function (t) {
            var e = n - (t - a);
            return d ? v(e, i - (t - f)) : e
          }(t))
        }

        function j(t) {
          return c = void 0, m && r ? g(t) : (r = o = void 0, u)
        }

        function O() {
          var t = p(), e = b(t);
          if (r = arguments, o = this, a = t, e) {
            if (void 0 === c) return w(a);
            if (d) return c = setTimeout(E, n), g(a)
          }
          return void 0 === c && (c = setTimeout(E, n)), u
        }

        return n = y(n) || 0, h(e) && (l = !!e.leading, i = (d = "maxWait" in e) ? s(y(e.maxWait) || 0, n) : i, m = "trailing" in e ? !!e.trailing : m), O.cancel = function () {
          void 0 !== c && clearTimeout(c), f = 0, r = a = o = c = void 0
        }, O.flush = function () {
          return void 0 === c ? u : j(p())
        }, O
      }
    }
  }, n = {};

  function e(r) {
    var o = n[r];
    if (void 0 !== o) return o.exports;
    var i = n[r] = {exports: {}};
    return t[r](i, i.exports, e), i.exports
  }

  e.n = t => {
    var n = t && t.__esModule ? () => t.default : () => t;
    return e.d(n, {a: n}), n
  }, e.d = (t, n) => {
    for (var r in n) e.o(n, r) && !e.o(t, r) && Object.defineProperty(t, r, {enumerable: !0, get: n[r]})
  }, e.g = function () {
    if ("object" == typeof globalThis) return globalThis;
    try {
      return this || new Function("return this")()
    } catch (t) {
      if ("object" == typeof window) return window
    }
  }(), e.o = (t, n) => Object.prototype.hasOwnProperty.call(t, n), (() => {
    "use strict";

    function t(t, n) {
      for (var e = 0; e < n.length; e++) {
        var r = n[e];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r)
      }
    }

    function n(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t
    }

    function r(t, n) {
      return r = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, n) {
        return t.__proto__ = n, t
      }, r(t, n)
    }

    function o(t) {
      return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      }, o(t)
    }

    function i(t, e) {
      if (e && ("object" === o(e) || "function" == typeof e)) return e;
      if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
      return n(t)
    }

    function u(t) {
      return u = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      }, u(t)
    }

    function c() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () {
        }))), !0
      } catch (t) {
        return !1
      }
    }

    function a(t, n, e) {
      return a = c() ? Reflect.construct.bind() : function (t, n, e) {
        var o = [null];
        o.push.apply(o, n);
        var i = new (Function.bind.apply(t, o));
        return e && r(i, e.prototype), i
      }, a.apply(null, arguments)
    }

    function f(t) {
      var n = "function" == typeof Map ? new Map : void 0;
      return f = function (t) {
        if (null === t || (e = t, -1 === Function.toString.call(e).indexOf("[native code]"))) return t;
        var e;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== n) {
          if (n.has(t)) return n.get(t);
          n.set(t, o)
        }

        function o() {
          return a(t, arguments, u(this).constructor)
        }

        return o.prototype = Object.create(t.prototype, {
          constructor: {
            value: o,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), r(o, t)
      }, f(t)
    }

    var l = void 0;
    var d = function t(n) {
        for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), o = 1; o < e; o++) r[o - 1] = arguments[o];
        return r.length >= n.length ? n.apply(void 0, r) : t.bind.apply(t, [l, n].concat(r))
      }, s = d((function (t, n) {
        return Array.isArray(n) ? n.map(t) : t(n)
      })), v = (d((function (t, n) {
        return Array.isArray(n) ? n.filter(t) : t(n) ? n : void 0
      })), function (t) {
        for (var n = arguments.length, e = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++) e[r - 1] = arguments[r];
        return t.bind.apply(t, [l].concat(e))
      }), p = function () {
        for (var t = arguments.length, n = new Array(t), e = 0; e < t; e++) n[e] = arguments[e];
        return function (t) {
          var e = this;
          return n.reduce((function (t, n) {
            return n.apply(e, [t])
          }), t)
        }
      }, h = d((function (t, n) {
        return n[t]
      })), y = (d((function (t, n) {
        return n < t
      })), d((function (t, n, e) {
        return e[t] = n, e
      })), d((function (t, n, e, r) {
        return r.reduce((function (t, r) {
          return setTimeout((function () {
            return e(r)
          }), t), t + n
        }), t)
      })), function t(n, e, r) {
        return n(r) ? t(n, e, e(r)) : r
      }), m = (d((function (t, n) {
        return n / t
      })), d((function (t, n) {
        return n * t
      })), d((function (t, n) {
        return -1 !== t.indexOf(n)
      })), d((function (t, n) {
        return t < 0 ? n[n.length + t] : n[t]
      }))), g = (m(1), m(-1)), w = d((function (t, n) {
        return n + t
      })), b = (p(g, w(1)), function (t) {
        return Array.prototype.slice.call(t)
      }), E = (d((function (t, n) {
        return n.then(t)
      })), d((function (t, n) {
        return n.catch(t)
      })), d((function (t, n) {
        return s((function (n) {
          return n.classList.add(t), n
        }), n)
      }))), j = (d((function (t, n) {
        return s((function (n) {
          return t.appendChild(n)
        }), n)
      })), d((function (t, n, e) {
        return e.style[t] = n, e
      }))("display", "none"), d((function (t, n) {
        return getComputedStyle(n)[t]
      })), h("clientHeight"), d((function (t, n) {
        return n.classList.contains(t)
      }))), O = function (t, n) {
        return n.getAttribute(t)
      }, T = (d(O), d((function (t, n, e) {
        return e.setAttribute(t, n), e
      }))), N = (d((function (t, n) {
        n.removeAttribute(t)
      })), d((function (t, n) {
        return O("data-" + t, n)
      })), d((function (t, n, e) {
        return T("data-" + t, n, e)
      })), function (t, n, e, r) {
        return r.addEventListener(t, n, e), r
      }), S = function (t, n, e, r) {
        return r.removeEventListener(t, n, e), r
      }, x = function (t, n) {
        for (var e = 0, r = ["matches", "matchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector", "webkitMatchesSelector"]; e < r.length; e++) {
          var o = r[e];
          if ("function" == typeof n[o]) return n[o](t)
        }
        return !1
      }, D = d((function (t, n, e) {
        return s(v(N, t, n, {}), e)
      })), L = (d((function (t, n, e) {
        return s(v(S, t, n, {}), e)
      })), d((function (t, n, e) {
        return s(v(N, t, n, {passive: !0}), e)
      })), d((function (t, n, e) {
        return s(v(N, t, n, !0), e)
      })), d((function (t, n) {
        return y((function (n) {
          return n && !x(t, n) && n.parentNode
        }), (function (t) {
          return t.parentNode === document ? null : t.parentNode
        }), n.parentNode)
      })), function (t, n, e, r) {
        return N(t, (function (t) {
          var o = y((function (t) {
            return t && t !== document && !x(e, t) && t.parentNode
          }), (function (t) {
            return t.parentNode
          }), t.target);
          o !== document && x(e, o) && n.apply(r, [t])
        }), {}, r)
      }), P = (d((function (t, n, e, r) {
        return s(v(L, t, n, e), r)
      })), d((function (t, n) {
        return s((function (n) {
          return n.classList.remove(t), n
        }), n)
      }))), A = (d((function (t, n) {
        return s((function (n) {
          return n.classList.toggle(t), n
        }), n)
      })), function (t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document;
        return n.querySelector(t)
      }), B = function (t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document;
        return b(n.querySelectorAll(t))
      },
      R = (p(h("children"), b), h("parentNode"), h("offsetTop"), h("value"), "undefined" != typeof window && window.navigator && window.navigator.platform && (/iPad|iPhone|iPod/.test(window.navigator.platform) || "MacIntel" === navigator.platform && navigator.maxTouchPoints), e(1296)),
      M = e.n(R);
    var _ = !1;
    if ("undefined" != typeof window) {
      var I = {
        get passive() {
          _ = !0
        }
      };
      window.addEventListener("testPassive", null, I), window.removeEventListener("testPassive", null, I)
    }
    var k = "undefined" != typeof window && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || "MacIntel" === window.navigator.platform && window.navigator.maxTouchPoints > 1),
      H = [], C = !1, F = -1, W = void 0, $ = void 0, q = function (t) {
        return H.some((function (n) {
          return !(!n.options.allowTouchMove || !n.options.allowTouchMove(t))
        }))
      }, Y = function (t) {
        var n = t || window.event;
        return !!q(n.target) || (n.touches.length > 1 || (n.preventDefault && n.preventDefault(), !1))
      }, z = function () {
        void 0 !== $ && (document.body.style.paddingRight = $, $ = void 0), void 0 !== W && (document.body.style.overflow = W, W = void 0)
      }, G = function (t, n) {
        if (t) {
          if (!H.some((function (n) {
            return n.targetElement === t
          }))) {
            var e = {targetElement: t, options: n || {}};
            H = [].concat(function (t) {
              if (Array.isArray(t)) {
                for (var n = 0, e = Array(t.length); n < t.length; n++) e[n] = t[n];
                return e
              }
              return Array.from(t)
            }(H), [e]), k ? (t.ontouchstart = function (t) {
              1 === t.targetTouches.length && (F = t.targetTouches[0].clientY)
            }, t.ontouchmove = function (n) {
              1 === n.targetTouches.length && function (t, n) {
                var e = t.targetTouches[0].clientY - F;
                !q(t.target) && (n && 0 === n.scrollTop && e > 0 || function (t) {
                  return !!t && t.scrollHeight - t.scrollTop <= t.clientHeight
                }(n) && e < 0 ? Y(t) : t.stopPropagation())
              }(n, t)
            }, C || (document.addEventListener("touchmove", Y, _ ? {passive: !1} : void 0), C = !0)) : function (t) {
              if (void 0 === $) {
                var n = !!t && !0 === t.reserveScrollBarGap, e = window.innerWidth - document.documentElement.clientWidth;
                n && e > 0 && ($ = document.body.style.paddingRight, document.body.style.paddingRight = e + "px")
              }
              void 0 === W && (W = document.body.style.overflow, document.body.style.overflow = "hidden")
            }(n)
          }
        } else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.")
      }, U = function () {
        k ? (H.forEach((function (t) {
          t.targetElement.ontouchstart = null, t.targetElement.ontouchmove = null
        })), C && (document.removeEventListener("touchmove", Y, _ ? {passive: !1} : void 0), C = !1), F = -1) : z(), H = []
      };

    function Z(t) {
      var n = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () {
          }))), !0
        } catch (t) {
          return !1
        }
      }();
      return function () {
        var e, r = u(t);
        if (n) {
          var o = u(this).constructor;
          e = Reflect.construct(r, arguments, o)
        } else e = r.apply(this, arguments);
        return i(this, e)
      }
    }

    var J = document.body, K = ".js-menu-navigation", Q = "js-menu-navigation", V = ".js-nav-dropdown",
      X = "js-nav-dropdown", tt = ".js-nav-dropdown-item", nt = ".js-brand-logo", et = "is-active", rt = "show-overlay",
      ot = "hidden", it = "hover", ut = "currentBrand", ct = ".js-menu-navigation-content", at = "mega-menu-active",
      ft = function (e) {
        !function (t, n) {
          if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(n && n.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {writable: !1}), n && r(t, n)
        }(a, e);
        var o, i, u, c = Z(a);

        function a() {
          var t, e, r;
          return function (t, n) {
            if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function")
          }(this, a), (t = c.call(this)).brandLogoEl = A(nt, n(t)), t.currentBrand = (e = ut, (r = document.cookie.match(new RegExp(e + "=([^;]+)"))) ? r[1] : null), t.currentBrandData = window.BRAND_CUSTOMIZERS[t.currentBrand], t.activeNav(), t.activeBrandLogo(), setTimeout((function () {
            t.activeDropdown(), t.menuNavigation = A(K, n(t)), t.navDropdown = A(V, n(t)), t.navDropdownItems = B(tt, t.navDropdown), t.attachEvent()
          }), 500), t
        }

        return o = a, (i = [{
          key: "attachEvent", value: function () {
            var t = this;
            if (this.menuNavigation && this.menuNavigation.children.length > 0) for (var n = function (n) {
              D("mouseover", M()((function () {
                t.menuNavigation.children[n].hasAttribute("data-dropdown") ? (E(et, t), E(rt, J), document.body.classList.contains(at) || document.body.classList.add(at), G(A(ct))) : (P(et, t), P(rt, J), U()), t.navDropdownItems.forEach((function (t) {
                  return E(ot, t)
                })), P(ot, t.navDropdown.children[n]), t.navDropdown.style.height = t.navDropdown.children[n].scrollHeight + "px", E(it, t.menuNavigation.children[n].children[0])
              }), 0), t.menuNavigation.children[n]), D("mouseout", M()((function () {
                t.navDropdown.style.height = 0, P(et, t), P(rt, J), P(it, t.menuNavigation.children[n].children[0]), U()
              }), 0), t.menuNavigation.children[n])
            }, e = 0; e < this.menuNavigation.children.length; e++) n(e);
            this.navDropdownItems && this.navDropdownItems.length > 0 && this.navDropdownItems.forEach((function (n, e) {
              D("mouseover", (function () {
                t.navDropdown.style.height = n.scrollHeight + "px", j(et, t) || E(et, t), j(rt, J) || E(rt, J), document.body.classList.contains(at) || document.body.classList.add(at), E(it, t.menuNavigation.children[e].children[0]), G(A(ct))
              }), n), D("mouseout", (function () {
                t.navDropdown.style.height = 0, P(et, t), P(rt, J), P(it, t.menuNavigation.children[e].children[0]), document.body.classList.remove(at), U()
              }), n)
            }))
          }
        }, {
          key: "activeBrandLogo", value: function () {
            var t, n, e = document.createElement("img");
            this.brandLogoEl.href = null === (t = this.currentBrandData) || void 0 === t ? void 0 : t.brand_template;
            e.src = null === (n = this.currentBrandData) || void 0 === n ? void 0 : n.brand_main_logo;
            var width = this.currentBrandData?.brand_logo_width || 123;
            var height = this.currentBrandData?.brand_logo_height || 42;
            e.width = width;
            e.height = height;
            e.alt = n.brand_logo_title || 'Compleat Angler';
            this.brandLogoEl.innerText = "";
            this.brandLogoEl.appendChild(e);
          }
        }, {
          key: "activeNav", value: function () {
            var t = this;
            B("[data-nav]", this).forEach((function (n) {
              P(Q, n), n.dataset.nav === t.currentBrand && (E(Q, n), n.removeAttribute("style"))
            }))
          }
        }, {
          key: "activeDropdown", value: function () {
            var t = this;
            B("[data-dropdown]", this).forEach((function (n) {
              P(X, n), n.dataset.dropdown === t.currentBrand && (E(X, n), P("hidden", n))
            }))
          }
        }]) && t(o.prototype, i), u && t(o, u), Object.defineProperty(o, "prototype", {writable: !1}), a
      }(f(HTMLElement));
    customElements.define("menu-navigation", ft)
  })()
})();